<template>
  <div class="flex flex-col gap-y-1">
    <div :class="direction" class="w-full flex gap-x-4 gap-y-1 text-brand-black-secondary">
      <label
        v-if="label"
        :for="fieldName"
        :class="labelClass"
        class="relative flex items-center gap-x-2"
      >
        <div>
          <span> {{ t9nLabel }}</span>
          <span v-if="isRequired" class="text-brand-red ps-1">*</span>
        </div>
        <HintTippy v-if="hint" :hint="hint"></HintTippy>
      </label>
      <div class="w-full flex flex-col gap-y-1">
        <InputAppendage v-if="appendages?.top" :styles="appendages?.styles">
          {{ $t(appendages?.top) }}
        </InputAppendage>
        <div class="w-full relative flex justify-start items-center">
          <input
            type="checkbox"
            class="accent-primary"
            :id="fieldName"
            :name="fieldName"
            :disabled="withIsDisabled"
            :value="value"
            :checked="value"
            @change="handleTickerChange"
          />
        </div>
        <InputAppendage v-if="appendages?.bottom" :styles="appendages?.styles">
          {{ $t(appendages?.bottom) }}
        </InputAppendage>
      </div>
    </div>
    <div v-if="hasError" class="w-full flex flex-col md:flex-row gap-x-4 gap-y-1 md:items-center">
      <div v-if="showErrorSpacer" class="w-full md:w-1/3"></div>
      <span class="w-full pt-[2px] text-brand-red ltr:font-sans text-xs">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script setup>
import HintTippy from '@/components/Form/HintTyppy.vue'
import InputAppendage from '@/components/Form/InputAppendage.vue'
import useRuleHandler from '@/composables/useRuleHandler'
import { useField } from 'vee-validate'
import { computed, toRef } from 'vue'
import { useI18n } from 'vue-i18n'

import useCheckBoxActions from '@/composables/actions/useCheckBoxActions'
import { useRoute } from 'vue-router'
import useVisible from '@/composables/useVisible'
const route = useRoute()
const { findShowRule, getBindObj } = useVisible()

const props = defineProps({
  hint: String,
  showPassword: Boolean,
  showPasswordBar: Boolean,
  trueValue: String,
  falseValue: String,
  fieldName: {
    type: String,
    required: true
  },
  label: {
    type: String
  },
  isDisabled: Boolean,
  defaultValue: {
    type: [Boolean, String],
    default: () => false
  },
  rules: Array,
  showRules: Object,
  direction: {
    type: String,
    default: 'flex-row md:items-center flex-col md:flex-row'
  },
  labelClass: {
    type: String,
    default: () => 'w-full md:w-1/3'
  },
  showErrorSpacer: {
    type: Boolean,
    default: () => true
  },
  trigger: String,
  onChange: Object,
  onBlur: Object,
  dependentOn: String,
  appendages: Object
})

const fieldName = toRef(props, 'fieldName')
const i18n = useI18n()

const { value, errorMessage, handleChange, meta } = useField(
  fieldName,
  (value) => useRuleHandler(value, props.rules),
  {
    initialValue: props.defaultValue
  }
)

const t9nLabel = computed(() => i18n.t(props.label || ''))
const hasError = computed(() => errorMessage.value && meta.touched)
const isRequired = computed(() => !!props.rules?.find((r) => r.name == 'required' || 'required_ui'))

const handleTickerChange = (e) => {
  let selectedValue = e.target.checked
  if (props.trueValue) {
    selectedValue = e.target.checked ? props.trueValue : props.falseValue
  }
  handleChange(selectedValue)
  if (props.trigger == 'change') {
    useCheckBoxActions()[props.onChange.action](selectedValue)
  }
}

const withIsDisabled = computed(() => {
  if (typeof props.isDisabled === 'boolean') {
    return props.isDisabled
  } else if (props.isDisabled && Object.keys(props.isDisabled).length > 0) {
    const result = findShowRule(
      props.isDisabled.any || props.isDisabled.all,
      props.isDisabled.any ? 'any' : 'all',
      getBindObj(route.params.serviceId)
    )

    return result
  } else {
    return false
  }
})
</script>

<style lang="scss" scoped></style>
